import React from 'react';
import { useInView } from '../hooks/useInView';

const ExperienceItem = ({ experience, monthNames }) => {
    const { ref, inView } = useInView();
    
    const startDate = new Date(experience.start_date.seconds * 1000);
    const stringStartDate = `${monthNames[startDate.getMonth()]} ${startDate.getFullYear()}`;
    const endDate = new Date(experience.end_date.seconds * 1000);
    let stringEndDate = endDate.getFullYear() < startDate.getFullYear() ? "Present" : `${monthNames[endDate.getMonth()]} ${endDate.getFullYear()}`;

    const techStackMap = new Map(Object.entries(experience.tech_stack));
    const responsibilities = experience.responsibilities.map((r, idx) => <li key={idx}>{r}</li>);
    const techStack = Array.from(techStackMap).map(([name, link]) => (
        <a
            key={name}
            className='experience-tech hover-lift-sm'
            href={link}
            target='_blank'
            rel="noreferrer">
            {name}
        </a>
    ));

    return (
        <div
            ref={ref}
            className={`experience-item fade-in-up hover-scale ${inView ? 'animation-active' : ''}`}>
            <img className='experience-logo' src={experience.logo_url} alt="" />
            <p className='experience-company'>{experience.company}</p>
            <p className='experience-role'>{experience.role}</p>
            <p className='experience-type'>({experience.type})</p>
            <p className='experience-location'>{experience.location}</p>
            <p className='experience-date'>{stringStartDate} - {stringEndDate}</p>
            <ul className='experience-responsibilities'>
                {responsibilities}
            </ul>
            <div className='experience-techstack-blocks'>
                {techStack}
            </div>
        </div>
    );
};

export default ExperienceItem;
